<template>
    <!-- Modal backdrop. This what you want to place close to the closing body tag -->
    <div
        v-show="isModalOpen"
        class="fixed inset-0 z-30 flex items-end bg-black bg-opacity-50 sm:items-center sm:justify-center p-10"
    >
        <!-- Modal -->
        <div
            class="w-full flex flex-col overflow-hidden h-screen max-h-full bg-white rounded-t-lg dark:bg-gray-800 sm:rounded-lg sm:m-4"
            role="dialog"
            id="modal"
        >
            <!-- Modal body -->
            <div class="px-6 py-4 border-b dark:border-gray-500 flex justify-between items-center">
                <p class="text-lg font-semibold text-gray-700 dark:text-gray-300">Preview Block Element</p>
            </div>

            <div class="mb-6 overflow-auto h-full">
                <div class="px-6 py-4 h-full">
                    <div class="border p-3 h-full">
                        <editor api-key="6fcut3p0963eupgz9i3rukd5fx5p6oj5teregn2fhr9w2r6l"
                                v-model="form.html"
                                :init="editorConfig"
                        ></editor>
                    </div>
                </div>
            </div>
            <footer
                class="flex flex-col items-center justify-end px-6 py-3 sm:flex-row bg-gray-50 dark:bg-gray-700"
            >
                <jet-button
                    @click.prevent="save"
                    type="button"
                    class="mr-2 w-full px-5 py-3 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-red-600 border border-transparent rounded-lg sm:w-auto sm:px-4 sm:py-2 active:bg-red-600 hover:bg-red-700 focus:outline-none focus:shadow-outline-red"
                >
                    Save
                </jet-button>
                <jet-button
                    @click.prevent="close"
                    type="button"
                    class="w-full px-5 py-3 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-red-600 border border-transparent rounded-lg sm:w-auto sm:px-4 sm:py-2 active:bg-red-600 hover:bg-red-700 focus:outline-none focus:shadow-outline-red"
                >
                    Cancel
                </jet-button>
            </footer>
        </div>
    </div>
    <!-- End of modal backdrop -->
</template>

<script>
import JetButton from '@/Jetstream/Button';
import Editor from '@tinymce/tinymce-vue'
import {useForm, usePage} from "@inertiajs/inertia-vue3";

export default {
    components: {
        JetButton,
        Editor
    },
    props: {
        isModalOpen: {
            type: Boolean,
            default: false,
        },
        client: {
            type: Object,
            required: false,
        },
        quote: {
            type: Object,
            required: true,
        },
        element: {
            type: Object,
            required: true,
        }
    },
    setup(props, {emit}) {
        const {csrf_token} = usePage().props.value;

        const form = useForm({
            html: props.element.html ?? '',
        });

        const close = () => {
            emit("close");
        };

        const save = () => {
            let saveRoute;
            if (props.client) {
                saveRoute = route('admin.quote.block.content.save', {
                    client: props.client.id,
                    quote: props.quote.id,
                    blockUuid: props.element.uuid
                });
            } else {
                saveRoute = route('admin.quote-template.block.content.save', {
                    quote_template: props.quote.id,
                    blockUuid: props.element.uuid
                });
            }
            form.put(saveRoute, {
                onSuccess: () => {
                    emit('html-changed', form.html);
                    close();
                }
            });
        }

        const editorConfig = {
            height: '100%',
            plugins: 'image imagetools code link',
            menubar: false,
            statusbar: false,
            toolbar: 'undo redo | styleselect| fontselect | fontsizeselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent | link | image code',
            fontsize_formats: "8pt 9pt 10pt 11pt 12pt 14pt 18pt 24pt 30pt 36pt 48pt 60pt 72pt 96pt",
            font_formats: "Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats; Segoe UI=Segoe UI,sans-serif;Arquitecta=Arquitecta,sans-serif",
            images_upload_url: props.client
                ? route('admin.quote.upload-image', {client: props.client.id, quote: props.quote.id})
                : route('admin.quote-template.upload-image', {quote_template: props.quote.id}),
            automatic_uploads: true,
            relative_urls: false,
            convert_urls: true,
            block_unsupported_drop: true,
            file_picker_types: 'file image media',
            images_upload_credentials: true,
            content_css: [
                props.client
                    ? route('admin.quote.block.style.show', {
                        client: props.client.id,
                        quote: props.quote.id,
                        blockUuid: props.element.uuid
                    })
                    : route('admin.quote-template.block.style.show', {
                        quote_template: props.quote.id,
                        blockUuid: props.element.uuid
                    })
            ],
            images_upload_handler: (blobInfo, success, failure, progress) => {
                let xhr, formData;

                xhr = new XMLHttpRequest();
                xhr.withCredentials = false;
                let saveUrl = props.client
                    ? route('admin.quote.upload-image', {client: props.client.id, quote: props.quote.id})
                    : route('admin.quote-template.upload-image', {quote_template: props.quote.id});
                xhr.open('POST', saveUrl);
                xhr.setRequestHeader("X-CSRF-Token", csrf_token);

                xhr.upload.onprogress = function (e) {
                    progress(e.loaded / e.total * 100);
                };

                xhr.onload = function () {
                    var json;

                    if (xhr.status === 403) {
                        failure('HTTP Error: ' + xhr.status, {remove: true});
                        return;
                    }

                    if (xhr.status < 200 || xhr.status >= 300) {
                        failure('HTTP Error: ' + xhr.status);
                        return;
                    }

                    json = JSON.parse(xhr.responseText);

                    if (!json || typeof json.location != 'string') {
                        failure('Invalid JSON: ' + xhr.responseText);
                        return;
                    }

                    success(json.location);
                };

                xhr.onerror = function () {
                    failure('Image upload failed due to a XHR Transport error. Code: ' + xhr.status);
                };

                formData = new FormData();
                formData.append('file', blobInfo.blob(), blobInfo.filename());
                formData.append('blockUuid', props.element.uuid);

                xhr.send(formData);
            },
        };

        return {
            form,
            close,
            save,
            editorConfig,
        }

    },
}
</script>

<style scoped>

</style>
